import { jwtDecode, JwtPayload } from "jwt-decode";
import React from "react";

type Props = {
  children?: React.ReactElement,
  jwtPayload: JwtPayload|any
}

export default function InvitoShowToken(props: Props) {
     return (
      <React.Fragment>
        <h4>Dettagli dell'invito</h4>
        <div>Email: <b>{props.jwtPayload.sub}</b></div>
        <div>Invito da: <b>{props.jwtPayload.inviteby_givename} {props.jwtPayload.inviteby_surname}</b></div>
        <div>Invitato a partecipare su: <b>{props.jwtPayload.tenant_name}</b></div>
      </React.Fragment>
    );

}